'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'door-closed';
var width = 448;
var height = 512;
var aliases = [128682];
var unicode = 'f52a';
var svgPathData = ['M64 64l0 416 320 0 0-416c0-17.7-14.3-32-32-32L96 32C78.3 32 64 46.3 64 64zM344 248a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M352 32c17.7 0 32 14.3 32 32l0 416-320 0 0-416c0-17.7 14.3-32 32-32l256 0zm64 448l0-416c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 416-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zM320 224a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorClosed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;